import env from 'enviro';
import { HUBSPOT_CREDITS_PAGE_V2, M1_HUB_PAGES, M2_BUNDLE_PAGES, M3_SMART_CRM_PAGES, PPFE_PRICING_PAGE_V2_ADD_ONS } from '../constants/Gates';
import { SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { hasAnyMarketingPlusSkuInProductData } from './productsUtils';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  var _gates$includes;
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);
  if (override === 'true' && isQA) {
    return true;
  }
  return (_gates$includes = gates === null || gates === void 0 ? void 0 : gates.includes(gateKey)) !== null && _gates$includes !== void 0 ? _gates$includes : false;
};
export const getIsUngatedForSeats = state => {
  const isUngatedByPublicFlagOrOverride = getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  });
  const urlParams = new URLSearchParams(window.location.search);
  const isUngatedByQueryParamOverride = urlParams.get('forceSeatsPricing') === 'true';
  const isUngatedOnPublic = isUngatedByPublicFlagOrOverride || isUngatedByQueryParamOverride;
  return isUngatedOnPublic || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getAreGatesPopulated = state => {
  return state.gates !== null && state.gates !== undefined;
};
export const getIsUngatedForMarketingPlus = state => {
  return hasAnyMarketingPlusSkuInProductData(state);
};
export const getIsUngatedForM1HubPages = state => getIsUngated(state, {
  gateKey: M1_HUB_PAGES
});
export const getIsUngatedForM2BundlePages = state => getIsUngated(state, {
  gateKey: M2_BUNDLE_PAGES
});
export const getIsUngatedForM3SmartCrmPages = state => getIsUngated(state, {
  gateKey: M3_SMART_CRM_PAGES
});
export const getIsUngatedForHubSpotCreditsPageV2 = state => getIsUngated(state, {
  gateKey: HUBSPOT_CREDITS_PAGE_V2
});
export const getIsUngatedForAddOnsPageV2 = state => getIsUngated(state, {
  gateKey: PPFE_PRICING_PAGE_V2_ADD_ONS
});